document.addEventListener('lazyloaded', function() {
  $('.matchheight_box-01, .matchheight_box-02, .matchheight_box-03, .matchheight_box-04, .matchheight_box-05, .matchheight_box--lg-01, .matchheight_box--lg-02, .matchheight_box--lg-03, .matchheight_box--lg-04, .matchheight_box--lg-05, .matchheight_box--pc-sp').css('height', '');
  if (window.matchMedia('(min-width: 769px)').matches) {
    $('.matchheight_box-01').matchHeight();
    $('.matchheight_box-02').matchHeight();
    $('.matchheight_box-03').matchHeight();
    $('.matchheight_box-04').matchHeight();
    $('.matchheight_box-05').matchHeight();
  }
  if (window.matchMedia('(min-width: 993px)').matches) {
    $('.matchheight_box--lg-01').matchHeight();
    $('.matchheight_box--lg-02').matchHeight();
    $('.matchheight_box--lg-03').matchHeight();
    $('.matchheight_box--lg-04').matchHeight();
    $('.matchheight_box--lg-05').matchHeight();
  }
  $('.matchheight_box--pc-sp').matchHeight();
});

$(window).on('resize orientationchange', function () {
  $(document).trigger('lazyloaded'); // 疑似的に再実行
});
